<template>
  <div>
    <div class="wrapper">
      <section class="side">
        <p class="main-msg">{{ $t('pricing5') }}</p>
        <ul class="secondary-msg">
          <li>{{ $t('pricing2') }}</li>
          <li>{{ $t('pricing3') }}</li>
          <li>{{ $t('pricing4') }}</li>
        </ul>
        <img src="../assets/static/icons/expar_logo_new.svg" alt="expar logo" />
      </section>

      <section class="main">
        <div class="backBtn">
          <a
            v-if="env === 'production'"
            href="https://expar.si/"
            class="previous"
            >&#8249; {{ $t('back') }}</a
          >
          <a v-else href="https://demo.expar.si/" class="previous"
            >&#8249; {{ $t('back') }}</a
          >
        </div>
        <div class="languageSwitcher">
          <language-switcher />
        </div>
        <p class="title">{{ $t('registration') }}</p>
        <div class="separator"></div>
        <p class="welcome-message">{{ $t('signupMsg') }}</p>

        <form @submit.prevent="register">
          <div class="form-control">
            <input
              v-model="firstName"
              type="text"
              data-qa="firstNameInput"
              name="firstName"
              :placeholder="$t('name')"
              v-on:input="errors = null"
              value
            />
            <!-- <i class="fas fa-user"></i> -->
            <i class="fas fa-user"></i>
          </div>
          <div class="form-control">
            <input
              v-model="lastName"
              type="text"
              data-qa="lastNameInput"
              name="lastName"
              :placeholder="$t('surname')"
              v-on:input="errors = null"
              value
            />
            <i class="fas fa-user"></i>
          </div>
          <div class="form-control">
            <input
              class="user-input"
              v-model="email"
              :class="{ 'error-boarder': $v.email.$error }"
              type="email"
              data-qa="emailInput"
              name="email"
              @blur="$v.email.$touch()"
              v-on="$listeners"
              :placeholder="$t('email')"
              v-on:input="errors = null"
              value
            />
            <i class="fas fa-envelope"></i>
          </div>
          <template v-if="$v.email.$error">
            <div v-if="!$v.email.email" class="errorMessage">
              {{ $t('emailValid') }}
            </div>
            <div v-if="!$v.email.required" class="errorMessage">
              {{ $t('emailReq') }}
            </div>
          </template>
          <div class="form-control">
            <input
              class="user-input"
              :type="passwordFieldType"
              v-model="password"
              :class="{ 'error-boarder': $v.password.$error }"
              data-qa="passwordInput"
              name="password"
              :placeholder="$t('password')"
              @blur="$v.password.$touch()"
              v-on="$listeners"
              v-on:input="errors = null"
              value
            />
            <i class="fas fa-lock"></i>
            <button class="eyeIcon" type="button" @click="switchVisibility">
              <span
                class="input-group-text"
                @click="showPassword = !showPassword"
              >
                <i
                  class="fa"
                  :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
                  aria-hidden="true"
                ></i>
              </span>
            </button>
          </div>
          <template v-if="$v.password.$error">
            <div v-if="!$v.password.required" class="errorMessage">
              {{ $t('passReq') }}
            </div>
          </template>
          <template v-if="$v.password.$invalid">
            <p v-if="!$v.password.maxLength" class="errorMessage">
              {{ $t('passMaxLength') }}
            </p>
          </template>
          <template v-if="$v.password.$invalid">
            <p v-if="!$v.password.minLength" class="errorMessage">
              {{ $t('passMinLength') }}
            </p>
          </template>
          <template v-if="this.submitted && $v.password.$error">
            <p v-if="password && !$v.password.valid" class="errorMessage">
              {{ $t('passValid') }}
            </p>
          </template>
          <!-- PROMO CODE accordion -->
          <div>
            <accordion>
              <accordion-item id="promoCode">
                <template slot="accordion-trigger">
                  <h5 class="haveCodeText">{{ $t('promoCode') }}</h5>
                </template>
                <template slot="accordion-content">
                  <div class="form-control">
                    <input
                      class="promoCode-input"
                      v-model="promoCode"
                      type="text"
                      data-qa="promoCodeInput"
                      name="promoCode"
                      :class="{ promoCodeEntered: $v.promoCode.$touch }"
                    />
                  </div>
                </template>
              </accordion-item>
            </accordion>
          </div>
          <!--End of PROMO CODE accordion -->
          <button
            :disabled="$v.$invalid || !gdprTerms1 || !gdprTerms2"
            class="action"
            type="submit"
            data-qa="signUpButton"
            name="button"
          >
            {{ $t('signup') }}
          </button>

          <div class="selected_area">
            <label class="form-control2">
              <input
                type="checkbox"
                data-qa="agreeOnTermsCheckbox"
                v-model="gdprTerms1"
              />
              <div class="label-text fa-lg">
                {{ $t('GDPRregistration1') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/splosni-pogoji-b2b-a/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration2') }}</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/splosni-pogoji-poslovan/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration2') }}</span>
                </a>
                {{ $t('GDPRregistration3') }}
              </div>
              <br />
              <!-- <div class="label-text disclaimer">
                {{ $t('GDPRregistration4') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration5') }}</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration5') }}</span>
                </a>
              </div> -->
            </label>
            <!-- <label class="form-control2">
              <input
                type="checkbox"
                data-qa="agreeOnTermsCheckbox"
                v-model="gdprTerms"
              />
              <div class="label-text fa-lg">
                {{ $t('GDPRregistration1') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration6') }}</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration6') }}</span>
                </a>
                {{ $t('GDPRregistration7') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('PrivacyPolicy') }}.</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('PrivacyPolicy') }}.</span>
                </a>
              </div>
            </label> -->
          </div>
          <div class="selected_area">
            <label class="form-control2">
              <input
                type="checkbox"
                data-qa="agreeOnTermsCheckbox"
                v-model="gdprTerms2"
              />
              <div class="label-text fa-lg">
                {{ $t('GDPRregistration1') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration6') }}</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('GDPRregistration6') }}</span>
                </a>
                {{ $t('GDPRregistration7') }}
                <a
                  v-if="env === 'production'"
                  class="gdprLink"
                  target="_blank"
                  href="https://expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('PrivacyPolicy') }}.</span>
                </a>
                <a
                  v-else
                  class="gdprLink"
                  target="_blank"
                  href="https://demo.expar.si/politika-zasebnosti/"
                >
                  <span class="gdprLink">{{ $t('PrivacyPolicy') }}.</span>
                </a>
              </div>
            </label>
          </div>

          <!-- <div v-if="this.errors" class="errorMessage">
				{{ this.errors }}
			</div> -->
        </form>
        <br />
        <!-- <div class="login">
				<p>{{ $t('haveAccount') }}</p>
				<button @click="redirectLogin">{{ $t('login') }}</button>
			</div> -->
        <sweet-modal icon="success" ref="modalSuccess" name="successModal">
          {{ $t('accountCreated') }}
          <br />
          <br />
          <button @click="login" class="info-btn" data-qa="signInButton">
            {{ $t('login') }}
          </button>
        </sweet-modal>
        <sweet-modal
          icon="error"
          title="Oh nooo…"
          ref="modalError"
          name="errorModal"
        >
          <p v-if="errors">{{ this.errors }}</p>
          <p v-else>{{ $t('errorMsg') }}</p>
          <!-- <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button> -->
        </sweet-modal>
        <!--2FA signin modal-->
        <!-- <sweet-modal icon="success" ref="modalSuccess" name="successModal2FA">
				{{ $t('accountCreated') }}
				<br />
				<br />
				<p>{{ $t('scanWithAuthenticationApp') }}</p>
				<div>QR CODE HERE (from Speakeasy)</div>
				<br />
				<p>{{ $t('verifyWithAuthenticationApp') }}</p>
				<form @submit.prevent="verifyAccount">
					<div class="form-control">
						<input
							class="user-input"
							v-model="verificationCode"
							:class="{ 'error-boarder': $v.verificationCode.$error }"
							data-qa="verificationCodeInput"
							name="password"
							:placeholder="$t('verificationCode')"
							@blur="$v.verificationCode.$touch()"
							v-on="$listeners"
							v-on:input="errors = null"
							value
						/>
						<i class="fas fa-lock"></i>
					</div>
				</form>
				<template v-if="$v.verificationCode.$error">
					<div v-if="!$v.verificationCode.required" class="errorMessage">
						{{ $t('verificationCodeReq') }}
					</div>
				</template>
				<br/>
				<button
				@click="login"
				class="info-btn"
				:disabled="$v.$invalid" 
				data-qa="signInButton"
				>
				{{ $t('confirmSignIn') }}
				</button>
				<br/>
				<p>{{ $t('2FADisclaimerToDisable') }}</p>
			</sweet-modal> -->
        <!--END OF 2FA signin-->
      </section>
    </div>
    <FooterLandingPage />
  </div>
</template>

<script>
import { required, email, maxLength, minLength } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios'
import publicIpAddress from 'public-ip'
import Accordion from '@/components/common/accordion'
import FooterLandingPage from '@/components/landingPage/FooterLandingPage.vue'
import AccordionItem from '@/components/common/accordion-item'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('register')
    }
  },
  components: {
    SweetModal,
    Accordion,
    AccordionItem,
    FooterLandingPage,
    LanguageSwitcher
  },
  data() {
    return {
      env: '',
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      role: 'client',
      errors: null,
      error: false,
      gdprTerms1: false,
      gdprTerms2: false,
      passwordFieldType: 'password',
      showPassword: false,
      submitted: false
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      valid: function(value) {
        const containsUppercase = /[A-Z]/.test(value)
        const containsLowercase = /[a-z]/.test(value)
        const containsNumber = /[0-9]/.test(value)
        const containsSpecial = /[ §"()=#?!@$%^&₹*-/_:;.'<>`[~{}|]/.test(value)
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        )
      },
      maxLength: maxLength(20),
      minLength: minLength(8)
    },
    promoCode: {}
  },
  created() {
    this.submitted = true
    this.env = process.env.NODE_ENV
    // return this.$v.$touch()
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid
    }
  },
  mounted() {
    this.env = process.env.NODE_ENV
  },
  methods: {
    register() {
      this.$store
        .dispatch('createClient', {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          role: this.role
        })
        .then(async response => {
          this.$refs.modalSuccess.open()
          await this.addSubscriptionPlan(this.email)
          await this.presetCategoryData(response.data.userId)
        })
        .catch(err => {
          this.errors = err.response.data.message
          this.$refs.modalError.open()
        })
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false // stop here if form is invalid
        // console.log("form submitted:", this.email);
      }
    },
    login() {
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.push({ name: 'dashboard' }) // automatically redirect to dashboard when user click "register"//
        })
        .catch(err => {
          this.error = err.data.message
        })
    },
    async presetCategoryData(clientId) {
      let countryDetails = JSON.parse(sessionStorage.getItem('country-details'))
      if (!countryDetails) {
        const publicIp = await publicIpAddress.v4()
        axios
          .get(`${process.env.VUE_APP_API_URL}/geolocate/${publicIp}`)
          .then(({ data }) => {
            countryDetails = data
            sessionStorage.setItem('country-details', JSON.stringify(data))
          })
      }
      this.$store.dispatch('client/addPresetcategoriesForClient', {
        client_id: clientId,
        country_id: countryDetails[0]['id']
      })
    },
    async addSubscriptionPlan(email) {
      const subscriptionJSON = {
        unit_count: 1,
        currency: 'eur',
        storage_value: 50,
        storage_unit: 'MB',
        status: 'trial',
        email: email
      }
      await this.$store.dispatch('insertSubscriptionDetails', subscriptionJSON)
      // this.$gtag.event('add-subscription', { method: 'Google' })
    },
    redirectLogin() {
      this.$emit('open-login', true)
      // this.$router.push({ name: 'login' });
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  },
  props: {
    from: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

.info-btn {
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn:hover {
  background: #0c4f60;
}

.wrapper {
  /* min-height: 100%; */
  display: grid;
  grid-template-columns: 60% 1fr;
  color: #696969;
}
.error-boarder {
  border: 2px solid var(--primaryDark);
}
.promoCodeEntered {
  background-color: var(--primarySuperLight);
  color: var(--bright);
  letter-spacing: 4px;
}
.haveCodeText {
  color: var(--primary);
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.promoCode-input {
  padding: 14px 44px;
}
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px;
}

.languageSwitcher {
  position: absolute;
  /* background-color: var(--bg); */
  top: 20px;
  right: 20px;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.secondary-msg {
  font-size: 1.4em;
  color: var(--bright);
  list-style-type: none;
  padding: 25px;
}

/* input[type='checkbox'] {
  display: inline-block;
  width: 15px;
  vertical-align: top;
} */
/* .red-input {
    accent-color: var(--primary);
	color: var(--bright);
    height: 20px; 
    width: 20px; 
} */

.eyeIcon {
  position: absolute;
  top: 20px;
  right: 20px;
}
.label-text {
  display: inline-block;
  text-align: justify;
  font-size: 0.75em;
  line-height: 1.2em;
}
.disclaimer {
  margin-top: 20px;
  margin-left: 20px;
}

.gdprLink {
  color: var(--bg);
  text-decoration: underline;
}
.gdprLink:hover {
  text-decoration: none;
  color: var(--primary);
}

/** Custom CheckBox Style*/

.form-control2 {
  /* font-family: system-ui, sans-serif;
  font-size: 2rem;
  font-weight: bold; */
  /* line-height: 1.1; */
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
}

.form-control2 + .form-control {
  margin-top: 1em;
}

.form-control2--disabled {
  color: var(--grey);
  cursor: not-allowed;
}

input[type='checkbox'] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--bright);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  padding: 0px !important;
  display: grid;
  place-content: center;
}

input[type='checkbox']::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--primary);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

input[type='checkbox']:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

input[type='checkbox']:disabled {
  --primary: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}

/** */

.side {
  background: linear-gradient(
    193deg,
    rgba(12, 46, 68, 1) 0%,
    rgba(61, 88, 105, 1) 28%,
    rgba(96, 93, 108, 1) 64%,
    rgba(251, 115, 119, 1) 100%
  );
  height: 100%;
}
.side img {
  width: 30%;
}
.side p {
  max-width: 500px;
  color: #ddfdff;
  letter-spacing: 1px;
  line-height: 1.8em;
  margin-bottom: 40px;
}
.side .main-msg {
  color: var(--bgDark);
  font-size: 3.2em;
  font-weight: 900;
  line-height: 1.2em;
  margin-bottom: 10px;
}
.title {
  font-size: 3em !important;
  font-weight: bold;
  text-align: center;
  letter-spacing: 1px;
  color: var(--bg);
}
.separator {
  width: 150px;
  height: 4px;
  background-color: var(--primary);
  margin: 24px;
}
.welcome-message {
  text-align: center;
  font-size: 1.1em;
  line-height: 28px;
  margin-bottom: 10px;
}
form {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
}
.form-control {
  width: 100%;
  position: relative;
  margin-bottom: 24px;
  border: none !important;
}

input,
button {
  border: none;
  outline: none;
  border-radius: 30px;
  font-size: 1.1em;
}

input {
  width: 100%;
  background: #e6e6e6;
  color: #333;
  letter-spacing: 0.5px;
  padding: 14px 64px;
}

input ~ i {
  position: absolute;
  left: 22px;
  top: 80%;
  transform: translateY(-50%);
  color: var(--gray);
  transition: color 0.4s;
  font-size: 1.3em;
}

input:focus ~ i {
  color: #0e484b;
}

button.action {
  color: #fff;
  padding: 14px 34px;
  margin: 32px auto;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;
  background-color: var(--primary);
  background: var(--primary);
  cursor: pointer;
  transition: opacity 0.4s;
}

button.action:hover {
  opacity: 0.9;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.login {
  position: absolute;
  bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login button {
  margin-left: 16px;
  background: none;
  color: var(--bg);
  border-bottom: 2px solid var(--bg);
  border-radius: 0;
  padding: 4px;
  cursor: pointer;
  font-weight: bold;
}

.login button:hover {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}

.login p {
  margin-bottom: 0;
}

/* Arrow Styling */
.backBtn {
  position: absolute;
  top: 20px;
  left: 30px;
}
.backBtn a {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}
.backBtn .previous {
  background-color: var(--bg);
  color: var(--bright);
}
/* END OF Arrow Styling */

/* ----  Responsiveness   ----  */
@media (min-width: 481px) {
  .backBtn a:hover {
    background-color: var(--primaryLight);
    color: var(--bg);
  }
  .backBtn a:active {
    background-color: var(--primaryLight);
    color: var(--bg);
  }
}

@media (max-width: 480px) {
  .backBtn {
    top: 10px;
    left: 10px;
  }
  .backBtn a:active {
    background-color: none !important;
    color: var(--primary);
  }
  .backBtn .previous {
    background-color: var(--bright);
    color: var(--bg);
  }
}

@media (max-width: 780px) {
  .wrapper {
    display: block;
  }
  .title {
    font-size: 2em !important;
  }
  .side {
    display: none;
  }
  section {
    padding: 4px;
  }
  .main {
    margin: 50px 20px;
  }
}

@media only screen and (min-width: 441px) {
  .label-text {
    width: 230px;
  }
}

@media only screen and (min-width: 900px) {
  .label-text {
    width: 300px;
  }
}

@media only screen and (min-width: 1200px) {
  .label-text {
    width: 350px;
  }
}

@media only screen and (min-device-width: 270px) and (max-device-width: 280px) {
  .label-text {
    width: 200px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
}

@media only screen and (min-device-width: 281px) and (max-device-width: 320px) {
  .label-text {
    width: 240px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
  .selected_area {
    margin-bottom: 50px;
  }
}
@media only screen and (min-device-width: 321px) and (max-device-width: 359px) and (orientation: portrait) {
  .label-text {
    width: 250px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 374px) and (orientation: portrait) {
  .label-text {
    width: 280px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 389px) and (orientation: portrait) {
  .label-text {
    width: 300px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
  .selected_area {
    margin-bottom: 20px;
  }
}

@media only screen and (min-device-width: 390px) and (max-device-width: 413px) and (orientation: portrait) {
  .label-text {
    width: 310px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
}

@media only screen and (min-device-width: 414px) and (max-device-width: 440px) and (orientation: portrait) {
  .label-text {
    width: 320px;
    font-size: 0.75em;
    line-height: 1.2em;
  }
}
</style>
